import { render, staticRenderFns } from "./FeeInformation.vue?vue&type=template&id=77bcb9b1&scoped=true"
import script from "./FeeInformation.vue?vue&type=script&lang=js"
export * from "./FeeInformation.vue?vue&type=script&lang=js"
import style0 from "./FeeInformation.vue?vue&type=style&index=0&id=77bcb9b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bcb9b1",
  null
  
)

export default component.exports